import { render, staticRenderFns } from "./logOffSuccess.vue?vue&type=template&id=3a2b3a0a&scoped=true"
import script from "./logOffSuccess.vue?vue&type=script&lang=js"
export * from "./logOffSuccess.vue?vue&type=script&lang=js"
import style0 from "./logOffSuccess.vue?vue&type=style&index=0&id=3a2b3a0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2b3a0a",
  null
  
)

export default component.exports